import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraggableBoardComponent } from './draggable-board.component';
import { SharedModule } from '../shared.module';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [
    DraggableBoardComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    DragDropModule
  ],
  exports: [
    DraggableBoardComponent
  ]
})
export class DraggableBoardModule { }
